<div class="db-ai">
    <div class="db-ai image">
      <img class="db-ai-image" src="assets/images/icons/ai-new-icon.png" alt=""/>
    </div>
    <div class="db-no-item-title"><span [innerHTML]="'text_aiEnableTitle' | dbText">{{'text_aiEnableTitle' | dbText}}</span></div>
    <div class="db-no-item-desc"><span [innerHTML]="'text_aiEnableDesc' | dbText">{{'text_aiEnableDesc' | dbText}}</span></div>
    <button class="ds-btn-blue" [ngClass]="{'ds-btn-disabled': false}" (click)="onEnable.emit()">
      <span *ngIf="true">Enable</span>
      <db-loading-circular-spinner *ngIf="false"></db-loading-circular-spinner>
    </button>
  </div>

